import { MapType } from './types';

export const mapTypeNext = (type: MapType): MapType =>
  type === MapType.Satellite ? MapType.Roadmap : MapType.Satellite;

export const secondsToTime = (
  t: (key: string) => string,
  s: number,
  remainingSecondsAsOneMinute: boolean = true,
) => {
  if (!s || s < 0) return '...';
  const days = Math.floor(s / (24 * 60 * 60));
  const hours = Math.floor((s % (24 * 60 * 60)) / (60 * 60));
  const minutes = Math.floor((s % (60 * 60)) / 60);
  const seconds = s % 60;

  const daysNames = [t('time.day'), t('time.days')];
  const hoursNames = [t('time.hour'), t('time.hours')];
  const minutesNames = [t('time.minute'), t('time.minutes')];
  const secondsNames = [t('time.second'), t('time.seconds')];

  const result = [];

  if (days > 0) {
    result.push(`${days} ${days === 1 ? daysNames[0] : daysNames[1]}`);
  }

  if (hours > 0) {
    result.push(`${hours} ${hours === 1 ? hoursNames[0] : hoursNames[1]}`);
  }

  if (minutes > 0) {
    result.push(`${minutes} ${minutes === 1 ? minutesNames[0] : minutesNames[1]}`);
  }

  if (seconds > 0 && !days && !hours && !minutes) {
    if (remainingSecondsAsOneMinute) {
      result.push(`1 ${minutesNames[0]}`);
    } else {
      result.push(`${seconds} ${seconds === 1 ? secondsNames[0] : secondsNames[1]}`);
    }
  }

  return result.join(' ');
};

export async function fetchFromFoursquare({
  url = '',
  p,
  lang = 'he',
  foursquareKey = '',
}: {
  url: string;
  p?: { [key: string]: string | number };
  lang?: string;
  foursquareKey: string;
}) {
  const params = new URLSearchParams(p);

  try {
    const response = await fetch(`${url}?${params.toString()}`, {
      headers: {
        Authorization: foursquareKey,
        Accept: 'application/json',
        'Accept-Language': lang,
      },
    });

    if (response.ok) {
      const data = await response.json();
      return {
        success: true,
        error: null,
        data,
      };
    } else {
      return {
        success: false,
        error: `Foursquare API Error: ${response.statusText}`,
        data: null,
      };
    }
  } catch (error) {
    console.error(error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Foursquare API: unknown error occurred',
      data: null,
    };
  }
}
export const foursquarePhotoLink = (prefix: string, suffix: string, size: string = '500x500') => {
  return prefix + size + suffix;
};

export const bbox = (coordinates: number[][]): [number, number, number, number] => {
  const result: [number, number, number, number] = [Infinity, Infinity, -Infinity, -Infinity];

  coordinates.forEach(([lng, lat]) => {
    if (result[0] > lng) result[0] = lng; // min lng
    if (result[1] > lat) result[1] = lat; // min lat
    if (result[2] < lng) result[2] = lng; // max lng
    if (result[3] < lat) result[3] = lat; // max lat
  });

  return result;
};
